import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { APP_SETTINGS } from '../models/backofficeConfiguration';
import { ExecuteService } from './executeService.service';
import { ErrorHandlerService } from './errorHandler.service';
import { Tag } from '../models/Tag';
import { CacheService } from './cache.service';

@Injectable()
export class TagService {
  private tagApiURL = APP_SETTINGS.TagApiUrl;

  constructor(private executeService: ExecuteService,
    private cacheService: CacheService,
    private errorHandler: ErrorHandlerService) {
  }

  public GetTagsByLanguage(culture: string): Observable<Tag[]> {
   
    const url = `${this.tagApiURL}${culture}/tagManager/get`;

    return  this.cacheService.get('get', this.executeService.Execute('get', url)
      .pipe(
      map(response => this.mapTagsModels(response.Tags)),
        catchError(this.errorHandler.handleError<object[]>('TagService_GetTags', []))
      ));
  }

  mapTagsModels(tags: any): any {
    let response: Tag[] = [];
    if (tags != null) {
      response = tags.map(tag => ({
        Id: tag.Id,
        Name: tag.Name
      }));
    }
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/tag.service.ts